module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticStyle: {
      "color": "#999999"
    }
  }, [_vm._v("入院状态:  \n            "), _c('span', {
    class: {
      blue: _vm.medicalInfo.signState == '已预约', green: _vm.medicalInfo.signState == '已入院'
    }
  }, [_vm._v(_vm._s(_vm.medicalInfo.signState))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "user-info"
  }, [_c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("医院")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.hospitalName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("登记号")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.patientId))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("病人姓名")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.name))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("性别")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.sex))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("年龄")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.age))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("身份证号码")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.medicalInfo.idCardNo)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.medicalInfo.phoneNo)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("病人类型")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.feeType))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("住院科室")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.deptName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("诊断类型")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.diagnosisType))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("开入院证医生")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.doctName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("开入院证时间")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.inTime))])])]), _vm._v(" "), (_vm.medicalInfo.signState == '已预约') ? _c('div', {
    staticClass: "diagnosis"
  }, [_c('span', {
    staticStyle: {
      "color": "#A2A2A2"
    }
  }, [_vm._v("诊疗描述:")]), _vm._v(" "), _c('div', {
    staticClass: "confirm"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicalInfo.diagnosisDesc),
      expression: "medicalInfo.diagnosisDesc"
    }],
    staticClass: "input",
    attrs: {
      "id": "input-content"
    },
    domProps: {
      "value": (_vm.medicalInfo.diagnosisDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicalInfo, "diagnosisDesc", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.medicalInfo.signState == '已入院') ? _c('div', {
    staticClass: "location",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("住院位置：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.location))])]) : _vm._e(), _vm._v(" "), (_vm.medicalInfo.signState == '已入院') ? _c('div', {
    staticClass: "footer",
    staticStyle: {
      "margin": "0.5rem 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("1、入院登记成功后，请前往住院预交金进行充值。")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("2、入院后，如需申请住院报销，请及时医保科进行登记。")])]) : _vm._e()]), _vm._v(" "), (_vm.medicalInfo.signState == '已预约') ? _c('div', {
    staticClass: "ok-wrap"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "feedback-submit",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitInpatient()
      }
    }
  }, [_vm._v("确认登记")])]) : _vm._e(), _vm._v(" "), (_vm.medicalInfo.signState == '已入院' && _vm.medicalInfo.status != '4') ? _c('div', {
    staticClass: "ok-wrap"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "feedback-submit",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goRecharge()
      }
    }
  }, [_vm._v("住院预交金充值")])]) : _vm._e(), _vm._v(" "), _c('tips', {
    model: {
      value: (_vm.showTips),
      callback: function($$v) {
        _vm.showTips = $$v
      },
      expression: "showTips"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "tip-content",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._v(_vm._s(_vm.tips))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "color-blue"
  }, [_vm._v("入院提示：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c1843b8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/inpatientRegister/InpatientDetails.vue
// module id = 783
// module chunks = 0